import { SUMMARY_ITEM_TYPES } from '@mixtiles/web-backend-shared'
import type {
  ProductItem,
  ShippingItem,
  SummaryItem,
  TaxItem,
} from './groupCheckoutPricing.types'

export function isShippingItem(item: SummaryItem): item is ShippingItem {
  return item.type === SUMMARY_ITEM_TYPES.SHIPPING
}

export function isTaxItem(item: SummaryItem): item is TaxItem {
  return item.type === SUMMARY_ITEM_TYPES.TAX
}

export function isProductItem(item: SummaryItem): item is ProductItem {
  return item.type === SUMMARY_ITEM_TYPES.PRODUCT
}
